<template>
  <!-- 借款订单 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="form.User" />
        </a-form-item>
        <a-form-item label="IP">
          <a-input v-model="form.IP" />
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker
            :default-value="[
              moment(getMindatetime(), dateFormat),
              moment().endOf('week'),
            ]"
            show-time
            :format="dateFormat"
            @change="onChange"
          />
        </a-form-item>
        <a-form-item label="订单类型">
          <a-select
            v-model="form.Sorte"
            style="width: 120px"
            @change="qryListAPI"
          >
            <a-select-option value="0"> 倒序</a-select-option>
            <a-select-option value="1"> 正序</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注">
          <a-input maxLength="500" v-model="form.Memo" />
        </a-form-item>
        <a-form-item v-if="role82">
          <a-button type="primary" @click="search()"
            ><a-icon type="search"
          /></a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      size="default"
      row-key="ID"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :loading="loading"
      :columns="columns"
      :data-source="data"
      :pagination="false"
      bordered
    >
      <template slot="title">
        <a-row :gutter="24">
          <a-col :span="5" style="line-height: 30px; width: 280px">
            借款订单 <span class="fontred">{{ clockNumer }}</span> 秒后刷新
            <a-button type="primary" @click="closeClock()">{{
              clockName
            }}</a-button>
          </a-col>
          <a-col style="float: right">
            <template v-if="role10">
              <a href="javascript:;" @click="BatchDelete()">
                <a-icon
                  type="delete"
                  style="font-size: 22px; color: red"
                ></a-icon>
                <span style="font-size: 15px; color: red">批量删除</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role78">
              <a href="javascript:;" @click="AllDelete()" v-if="false">
                <a-icon
                  type="delete"
                  style="font-size: 22px; color: red"
                ></a-icon>
                <span style="font-size: 15px; color: red">删除所有</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role9">
              <a href="javascript:;" @click="BatchLockAPI(1)">
                <a-icon type="lock" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量锁定</span>
              </a>
              &nbsp; &nbsp;
              <a href="javascript:;" @click="BatchLockAPI(2)">
                <a-icon type="unlock" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量解锁</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role77">
              <a href="javascript:;" @click="AllExport()">
                <a-icon type="file-excel" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">导出所有数据</span>
              </a>
              &nbsp; &nbsp;
              <a href="javascript:;" @click="QryExport()">
                <a-icon type="file-excel" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">导出筛选数据</span>
              </a>
            </template>
          </a-col>
        </a-row>
      </template>
      <template slot="User" slot-scope="text, record">
        <a @click="UserRoute(record.User)">{{ text }}</a>
      </template>
      <template slot="status" slot-scope="text">
        <span v-if="text == 1">待审核</span>
        <span v-if="text == 2">审核通过</span>
        <span v-if="text == 3">审核未通过</span>
      </template>
      <template slot="ldt" slot-scope="text, record">
        <div v-if="record.Status === 1"><span>提交: </span>{{ text }}</div>
        <div v-if="record.Status !== 1">
          <span>提交: </span>{{ text }}
          <br />
          <span>审核: </span>{{ record.Verify }}
        </div>
      </template>
      <template slot="operate" slot-scope="text, record">
        <template v-if="role9">
          <template v-if="record.Locking === ''">
            <a-tooltip>
              <template slot="title"> 锁定 </template>
              <a-popconfirm title="确定要锁定?" @confirm="() => onLock(record)">
                <a href="javascript:;">
                  <a-icon type="lock" style="font-size: 22px"></a-icon>
                </a>
              </a-popconfirm>
            </a-tooltip>
            &nbsp;
          </template>
          <template v-else>
            <template v-if="record.Locking === UserID">
              <a-tooltip>
                <template slot="title"> 解锁 </template>
                <a-popconfirm
                  title="确定要解锁?"
                  @confirm="() => onUnLock(record)"
                >
                  <a href="javascript:;">
                    <a-icon type="unlock" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
              &nbsp;
            </template>
            <template v-else>
              <a-tooltip>
                <template slot="title"> 已锁定 </template>
                <a-icon
                  type="lock"
                  style="font-size: 22px; color: #52c41a"
                ></a-icon>
              </a-tooltip>
              &nbsp;
            </template>
          </template>
        </template>
        <template v-if="record.Locking === '' || record.Locking === UserID">
          <a-tooltip>
            <template slot="title"> 编辑 </template>
            <a href="javascript:;" @click="onEdit(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
        <template v-if="role10">
          &nbsp;
          <a-tooltip>
            <template slot="title"> 删除 </template>
            <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
              <a href="javascript:;">
                <a-icon type="delete" style="font-size: 22px"></a-icon>
              </a>
            </a-popconfirm>
          </a-tooltip>
        </template>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination
        style="float: right"
        show-size-changer
        :default-current="pagination.current"
        :total="pagination.total"
        :show-total="(total) => `共 ${total} 条`"
        :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange"
        @showSizeChange="sizeChange"
      />
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="编辑" @ok="modalOk">
      <a-form-model
        :model="formModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="会员账号">
          <a-input v-model="formModel.User" placeholder="会员账号" read-only />
        </a-form-model-item>
        <a-form-model-item label="名字">
          <a-input v-model="formModel.UserName" placeholder="名字" />
        </a-form-model-item>
        <a-form-model-item label="借款金额">
          <a-input v-model="formModel.Money" read-only />
        </a-form-model-item>
        <a-form-model-item label="借款天数">
          <a-input v-model="formModel.Day" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <template v-if="formModel.stats">
            <a-select v-model="formModel.Status">
              <a-select-option value="1"> 待审核</a-select-option>
              <a-select-option value="2"> 审核通过</a-select-option>
              <a-select-option value="3"> 审核未通过</a-select-option>
            </a-select>
          </template>
          <template v-else>
            <a-input value="已审核，不允许再次操作" read-only />
          </template>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea
            v-model="formModel.Memo"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import XLSX from "xlsx";
import moment from "moment";
import { jsonExportSheet } from "../../js/xlsxTool";

export default {
  data() {
    return {
      /*** 权限
        8 借款订单新增/编辑
        9	借款订单锁定
        10	借款订单删除
        77	借款订单导出
        78	借款订单删除所有
        82	借款订单查询
       */
      role8: false,
      role9: false,
      role10: false,
      role77: false,
      role78: false,
      role82: false,
      UserID: sessionStorage.UserID,
      visible: false, //弹框状态
      formModel: {}, // 弹框字段
      formData: {},
      clockNumer: 15,
      clockName: "停止刷新",
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      data: [],
      columns: [
        {
          title: "ID",
          dataIndex: "ID",
          align: "center",
          sorter: (a, b) => a.ID - b.ID,
        },
        {
          title: "用户名",
          dataIndex: "User",
          align: "center",
          scopedSlots: { customRender: "User" },
        },
        {
          title: "姓名",
          dataIndex: "UserName",
          align: "center",
        },
        {
          title: "金额",
          dataIndex: "Money",
          align: "center",
        },
        {
          title: "天数",
          dataIndex: "Day",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "Status",
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "IP",
          dataIndex: "IP",
          align: "center",
        },
        {
          title: "备注",
          dataIndex: "Memo",
          align: "center",
        },
        {
          title: "时间",
          dataIndex: "Ldt",
          align: "center",
          scopedSlots: { customRender: "ldt" },
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        sizeList: ["10", "50", "500", "5000", "10000"],
      },
      selectedRowKeys: [], // 勾选此处配置默认列
      loading: false,
      form: { Status: "1",Sorte:"0" },
      borrowPolling: undefined,
    };
  },
  methods: {
    moment,
    //分页页数的改变
    pageNumberChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    //  分页显示条数的变化
    sizeChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    // 搜索
    search() {
      this.pagination.current = 1;
      this.qryListAPI();
    },
    // 查询API
    qryListAPI() {
      this.loading = true;
      this.axios
        .post("/borroworder/getqrylist", {
          User: this.form.User == undefined ? "" : this.form.User,
          IP: this.form.IP == undefined ? "" : this.form.IP,
          Status: this.form.Status,
          Sdate: this.form.Sdate,
          Edate: this.form.Edate,
          Sorte: this.form.Sorte,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
          Memo : this.form.Memo == undefined ? "" :this.form.Memo,
        })
        .then((res) => {
          if (res.data) {
            this.pagination.total = res.total;
            this.loading = false;
            this.data = res.data;
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 查询时间绑定
    onChange(value, dateString) {
      this.form.Sdate = dateString[0];
      this.form.Edate = dateString[1];
    },
    // 锁定
    onLock(data) {
      this.axios
        .post("/borroworder/batchlock", {
          IDList: [{ ID: data.ID }],
          Status: 1,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("锁定成功");
            this.qryListAPI();
          }
        });
    },
    // 解锁
    onUnLock(data) {
      this.axios
        .post("/borroworder/batchlock", {
          IDList: [{ ID: data.ID }],
          Status: 2,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("解锁成功");
            this.qryListAPI();
          }
        });
    },
    // 解锁、锁定API
    BatchLockAPI(type) {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warning("请勾选数据");
        return;
      }
      let msg = type === 1 ? "锁定" : "解锁";
      const that = this;
      this.$confirm({
        title: "订单" + msg,
        content: "您要确定要" + msg + "勾选数据吗?",
        onOk() {
          const idList = [];
          that.selectedRowKeys.forEach((element) => {
            idList.push({ ID: element });
          });
          that.axios
            .post("/borroworder/batchlock", {
              IDList: idList,
              Status: type,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success(msg + "成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 编辑
    onEdit(data) {
      this.visible = true;
      this.formModel = { ...data };
      this.formData = { ...data };
      this.formModel.stats = data.Status == 1;
      this.formModel.Status = "" + data.Status;
    },
    // 删除
    onDelete(data) {
      this.axios
        .post("/borroworder/batchdelete", { IDList: [{ ID: data.ID }] })
        .then((res) => {
          if (res.data) {
            this.$message.success("删除成功");
            this.qryListAPI();
          }
        });
    },
    // 勾选删除
    BatchDelete() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warning("请勾选数据");
        return;
      }
      const that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除勾选数据吗?",
        onOk() {
          const idList = [];
          that.selectedRowKeys.forEach((element) => {
            idList.push({ ID: element });
          });
          that.axios
            .post("/borroworder/batchdelete", {
              IDList: idList,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 删除所有
    AllDelete() {
      const that = this;
      this.$confirm({
        title: "删除所有",
        content: "您要确定要删除所有数据吗?",
        onOk() {
          that.axios.post("/borroworder/alldelete", {}).then((res) => {
            if (res.data) {
              that.$message.success("删除成功");
              that.qryListAPI();
            }
          });
        },
      });
    },
    // 编辑确认
    modalOk() {
      // 弹框确认动作
      this.axios.post("/borroworder/save", this.formModel).then((res) => {
        if (res.data) {
          this.$message.success("编辑成功");
          this.qryListAPI();
          this.visible = false;
        }
      });
    },
    // 数据导出
    DataExport(data) {
      this.axios.post("/borroworder/getqryexport", data).then((res) => {
        if (res.data) {
          if (res.data.length > 0) {
            var sheet = XLSX.utils.json_to_sheet(res.data);
            sheet["A1"].v = "编号";
            sheet["B1"].v = "用户名";
            sheet["C1"].v = "姓名";
            sheet["D1"].v = "金额";
            sheet["E1"].v = "天数";
            sheet["F1"].v = "状态";
            sheet["G1"].v = "IP";
            sheet["H1"].v = "备注";
            sheet["I1"].v = "提交时间";
            sheet["J1"].v = "审核时间";
            jsonExportSheet(sheet, this.moment().format("YYYYMMDDhhmmss"));
          } else {
            this.$message.warning("无数据导出!");
          }
        }
      });
    },
    UserRoute(obj){
      this.$router.push({
          name:'user',
          params:{
            name:'user',
              userid:obj,
          }
      });
    },
    // 导出筛选
    QryExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出所有数据吗？",
        onOk() {
          that.DataExport({
            User: that.form.User,
            Sdate: that.form.Sdate,
            Edate: that.form.Edate,
            IP: that.form.IP,
            Status: that.form.Status,
            Memo : that.form.Memo == undefined ? "" :that.form.Memo,
          });
        },
      });
    },
    // 导出所有
    AllExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出筛选数据吗？",
        onOk() {
          that.DataExport({
            User: "",
            Sdate: "",
            Edate: "",
            IP: "",
            Status: 0,
            Memo : "",
          });
        },
      });
    },
    //计时
    clockborrow() {
      const routes = this.$route.matched.concat().pop();
      if (routes.name === "borroworder") {
        //clearInterval(this.borrowPolling); //关闭
        if (this.clockNumer === 1) {
          this.qryListAPI();
          this.clockNumer = 15;
        } else if (!this.loading) {
          this.clockNumer = this.clockNumer - 1;
        }
      }
    },
    closeClock() {
      if (this.clockNumer !== "--") {
        this.clockName = "启动刷新";
        this.borrowPolling = clearInterval(this.borrowPolling);
        this.clockNumer = "--";
      } else {
        this.clockName = "停止刷新";
        this.borrowPolling = self.setInterval(this.clockborrow, 1000);
        this.clockNumer = 15;
      }
    },
    getMindatetime() {
      let time = sessionStorage.BorrowMin;
      if (new Date(sessionStorage.BorrowMin).getFullYear() == 1) {
        time = moment().startOf("week").format(this.dateFormat);
      }
      return this.getDate(time, "yyyy-MM-dd HH:mm:ss");
    },
  },
  
  //首次加载
  created() {
    // 初始化时间
    this.form.Sdate = this.getMindatetime(); //moment().startOf("week").format(this.dateFormat);
    this.form.Edate = moment().endOf("week").format(this.dateFormat);
    this.qryListAPI();
    this.borrowPolling = self.setInterval(this.clockborrow, 1000);
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [8, 9, 10, 77, 78, 82];
    var isRole = roleID.filter(function (item) {
      return array.indexOf(item) != -1;
    });
    //功能权限获取
    isRole.forEach((element) => {
      this["role" + element] = true;
    });
  },
};
</script>

<style>
.fontred {
  color: #ff4d4f;
  font-size: 15px;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/ordermanage/borroworder.vue